import React from 'react';
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import useInput from '../../utils/common/customHook';

import {
  ButtonInputComment,
  DivCommentInput,
  DivInputComment,
  LabelTitleComment,
} from '../styled';
import {
  BG_COLOR_BLACK,
  ICON_SUCCESS,
  TITLE_COMMENT,
  TITLE_GIVE_COMMENT,
  TITLE_GIVE_COMMENT_EN,
  TITLE_SEND,
  TITLE_SEND_EN,
  WHITE_COLOR,
} from '../../utils/common/constant';

const CommentInput = ({ onCreateComment }) => {
  const [content, onContentChange] = useInput('');
  const locale = 'en';

  const createComment = () => {
    if (content.trim()) {
      onCreateComment(content);
      document.getElementsByClassName('input-comment').comment.innerText = '';
      Swal.fire({
        icon: ICON_SUCCESS,
        title: TITLE_COMMENT,
        text: 'Berhasil menambah komentar',
        color: WHITE_COLOR,
        background: BG_COLOR_BLACK,
      });
    }
  };

  return (
    <DivCommentInput>
      <LabelTitleComment htmlFor="name">{locale === 'id' ? TITLE_GIVE_COMMENT : TITLE_GIVE_COMMENT_EN}</LabelTitleComment>
      <DivInputComment type="" id="comment" className="input-comment" data-testid="comment" contentEditable onInput={onContentChange} />
      <ButtonInputComment type="button" aria-label="comment" onClick={createComment}>{locale === 'id' ? TITLE_SEND : TITLE_SEND_EN}</ButtonInputComment>
    </DivCommentInput>
  );
};

CommentInput.defaultProps = {
  onCreateComment: null,
};

CommentInput.propTypes = {
  onCreateComment: PropTypes.func,
};

export default CommentInput;
